import { render, staticRenderFns } from "./objectStageSetAdd.vue?vue&type=template&id=5af24908"
import script from "./objectStageSetAdd.vue?vue&type=script&lang=js"
export * from "./objectStageSetAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af24908')) {
      api.createRecord('5af24908', component.options)
    } else {
      api.reload('5af24908', component.options)
    }
    module.hot.accept("./objectStageSetAdd.vue?vue&type=template&id=5af24908", function () {
      api.rerender('5af24908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectStageSetAdd.vue"
export default component.exports